import { createSelector } from 'reselect';
import { getState } from './state';
const empty = [];
export const getDraftSlice = createSelector([
    getState
], (slice)=>{
    return slice.drafts;
});
export const getDraftMessage = createSelector(getDraftSlice, (state, room_id)=>room_id, (state, room_id)=>{
    return state.messages[room_id];
});
export const getDraftMessageAttachments = createSelector(getDraftSlice, (state, room_id)=>room_id, (state, room_id)=>{
    var _state_messages_room_id;
    var _state_messages_room_id_attachments;
    return (_state_messages_room_id_attachments = (_state_messages_room_id = state.messages[room_id]) === null || _state_messages_room_id === void 0 ? void 0 : _state_messages_room_id.attachments) !== null && _state_messages_room_id_attachments !== void 0 ? _state_messages_room_id_attachments : empty;
});
export const getUnfurlLogForRoom = createSelector(getDraftSlice, (state, room_id)=>room_id, (state, room_id)=>{
    var _state_unfurlLog_room_id;
    return (_state_unfurlLog_room_id = state.unfurlLog[room_id]) !== null && _state_unfurlLog_room_id !== void 0 ? _state_unfurlLog_room_id : empty;
});
export const getIsUnfurlResolving = createSelector(getDraftSlice, (state)=>{
    return state.unfurlResolving;
});

//# sourceMappingURL=drafts.js.map